import React from 'react';
import FinancialReportsPanel from './FinancialReportsPanel';

const ExpenseReportsPanel: React.FC<{ onBack?: () => void }> = ({ onBack }) => (
  <FinancialReportsPanel module="expense" onBack={onBack} />
);

export default ExpenseReportsPanel;
